<template>
    <div class="con">
        <div class="one">
            <p>
                If you are interested in our products and services, please leave your email and<br>
                we will get in touch with you as soon as possible.
            </p>
            <div class="send">
                <input type="text" v-model="form.email">
                <span @click="send">SEND</span>
            </div>
        </div>
        <div class="two">
            <div class="tCon">
                <!--      <div class="left">-->
                <!--          <img src="../assets/yz/footLogo.png" alt="">-->
                <!--      </div>-->
                <div class="nav">
                    <div class="right" v-for="(item,index) in rightList" :key="index">
                        <p v-for="(i,ind) in item.conList" :key="ind" @click="goto(index,ind)">{{i}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="three">
            <p>© Copyright {{ year }} VIVANCOAll Rights Reserved.
                <a href="//www.seniorweb.cn/" target="_blank">Design in by seniorweb</a>
            </p>
            <div>
                <a href="https://www.facebook.com/VivancoGlobalSolutions/" target="_blank">
                    <i class="iconfont icon-Ankerwebicon-"></i>
                </a>
                <a href="https://www.linkedin.com/company/vivanco-global-solutions/" target="_blank">
                    <i class="iconfont icon-ins"></i>
                </a>
                <a href="https://www.youtube.com/channel/UCDtTBo1CjkN8rjuV15buMoA" target="_blank">
                    <i class="iconfont icon-youtobe"></i>
                </a>

            </div>
        </div>
    </div>
</template>

<script>
    import qs from 'qs'

    export default {
        name: "foot",
        data() {
            return {
                year:'',
                form: {
                    email: ''
                },
                rightList: [
                    {
                        conList: [
                            "About Vivanco",
                            "About Us",
                            "Manufacturing",
                            "R&D Center",
                            "Global Presence"
                        ]
                    },
                    {
                        conList: ["Contact Us", "World Headquarters",
                            "Find a Distributor"]
                    },
                    {
                        conList: [
                            "Download Center",
                            "Catalogue",
                            "Products Spec Sheet",
                            "Case Study",
                            "Technical Manuals",
                            "Videos",
                        ]
                    },
                    {
                        conList: ["Technical Support", 
                            "Warranty",
                            "Training Course",
                            "Knowledge Base"
                            ]
                    },
                    {
                        conList: ["Media Center", "News",
                            "Events"]
                    },
                    {
                        conList: ["Join Us",
                            "To be a Distributor",
                            "Careers at Vivanco"]
                    }
                ]
            }
        },
        mounted(){
          var time=new Date()
          this.year=time.getFullYear()
        },
        methods: {
            goto(n, i) {
                const alink = '/about.html'
                const alink2 = `/about.html?index=${i - 1}`
                const clink = '/contact.html'
                const clink2 = '/contact2.html'
                const slink = '/warranty.html'
                const slink2 = `/warranty.html?index=${i - 1}`
                const mlink = '/media.html'
                const mlink2 = `/media.html?index=${i - 1}`
                const jlink = '/join.html'
                const jlink2 = `/join.html?index=${i - 1}`
                console.log(n, i)
                if (n === 1 && i === 0) {
                    window.open(clink, '_self')
                } else if (n === 1 && i === 1) {
                    window.open(clink, '_self')
                } else if (n === 1 && i === 2) {
                    window.open(clink2, '_self')
                } else if (n === 2 && i == 3) {
                    const link = `/support.html?index=1?num=5`
                    window.open(link, '_self')
                } else if (n === 2 && i !== 0) {
                    const link = `/support.html?index=1?num=${i - 1}`
                    window.open(link, '_self')
                } else if (n === 3 && i === 0) {
                    window.open(slink, '_self')
                } else if (n === 3 && i == 1) {
                    window.open(slink2,'_self')
                } else if (n === 0 && i === 0) {
                    window.open(alink, '_self')
                } else if (n === 0 && i !== 0) {
                    window.open(alink2, '_self')
                } else if (n === 4 && i === 0) {
                    window.open(mlink, '_self')
                } else if (n === 4 && i !== 0) {
                    window.open(mlink2, '_self')
                } else if (n === 5 && i === 0) {
                    window.open(jlink, '_self')
                } else if (n === 5 && i !== 0) {
                    window.open(jlink2, '_self')
                }
            },
            send() {
                if (this.form.email !== '') {
                    this.$nextTick(() => {
                        const url = '/php/form.php'
                        this.$axios.post(url,
                            qs.stringify(
                                this.form
                            )
                        ).then(res => {
                            if (res.status === 200) {
                                this.$notify({
                                    title: 'Success',
                                    message: 'Submitted Successfully',
                                    offset: 100
                                })
                                this.form = {
                                    email: ''
                                }
                            } else {
                                this.$notify({
                                    title: 'Failure',
                                    message: '提交失败',
                                    offset: 100
                                });
                            }
                        })
                    })
                } else {
                    this.$notify({
                        title: 'Failure',
                        message: 'Please fill in the correct format email address',
                        offset: 100
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .con {
        width: 100%;

        .one {
            width: 100%;
            background: url("../assets/yz/msg.png") no-repeat;
            display: flex;
            background-size: 100% 100%;
            flex-direction: column;
            align-items: center;
            padding: 20px 0;

            p {
                font-family: "Fira Code Medium";
                color: white;
                font-size: 20px;
                margin-bottom: 30px;
                line-height: 30px;
                font-weight: lighter;
                text-align: center;
            }

            .send {
                input {
                    width: 450px;
                    height: 40px;
                    background: none;
                    outline: none;
                    border: none;
                    border: 1px solid rgba(255, 255, 255, .4);
                    color: white;
                    text-indent: 10px;
                }

                input:focus {
                    border-color: rgba(255, 255, 255, .4) !important;
                }

                span {
                    color: #717171;
                    padding: 13px 15px;
                    border-bottom: 1px solid #D3D3D3;
                    margin-left: 20px;
                    cursor: pointer;
                    transition: all 600ms;
                }

                span:hover {
                    color: #91C131;
                    border-color: #91C131;
                }
            }
        }

        .two {
            width: 100%;

            .tCon {
                width: 90%;
                margin: 0 auto;
                display: flex;
                flex-direction: row;
                padding: 20px 0;

                .left {
                    margin-left: 50px;
                }

                .nav {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    font-size: 14px;
                    justify-content: space-between;

                    .right {
                        display: flex;
                        flex-direction: column;
                        padding-left: 30px;
                        padding-right: 30px;
                        margin-left: 2%;
                        color: #8C8C8C;
                        text-align: start;
                        line-height: 30px;

                        p {
                            font-family: "Fira Code Medium";
                            cursor: pointer;
                            transition: color 2s;
                            color: #8C8C8C;
                            font-weight: lighter;
                        }

                        p:first-child {
                            font-size: 15px;
                            color: #342B25;
                            padding-bottom: 10px;
                        }

                        p:hover {
                            color: #91C131;
                        }
                    }

                    .right:nth-of-type(3) {
                        p:nth-child(3) {
                            display: none;
                        }
                    }
                }
            }
        }

        .three {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 15px 0;
            background-color: #F1F1F1;

            p {
                margin-left: 39%;
                font-family: "Fira Code Medium";
                font-weight: lighter;
                font-size: 15px;
                color: #5A5A5A;

                a {
                    margin-left: 20px;
                    transition: all 600ms;
                }

                a:hover {
                    color: #91C131;
                }
            }

            div {
                margin-right: 5%;

                i {
                    font-size: 20px;
                    padding-left: 15px;
                    color: #B6B6B6;
                    cursor: pointer;
                    transition: all 600ms;
                }

                i:hover {
                    color: #91C131;
                }
            }
        }

        @media screen and (max-width: 1440px) {
            .two {
                .tCon {
                    width: 100%;
                    margin-left: 0%;

                    .nav {
                        .right {
                            padding-left: 0;
                        }
                    }
                }
            }
        }
        @media screen and (max-width: 1000px) {
            .one {
                text-align: center;
                p {
                    font-size: 16px;
                    width: 80%;
                    /*margin-left: 10%;*/
                    margin-bottom: 30px;
                }

                .send {
                    width: 80%;
                    input {
                        width: 100%;
                    }

                    span {
                        margin:0 auto;
                        display: block;
                        width: 80px;
                        text-align: center;
                        margin-top: 10px;
                    }
                }
            }
            .two {
                .tCon {
                    justify-content: center;
                    padding: 0;

                    .left {
                        margin-left: 0;
                    }

                    .nav {
                        display: none;
                    }
                }
            }
            .three {
                padding: 10px 0;
                flex-direction: column;
                p{
                    margin: 0 auto;
                }
                div{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
</style>
